import {deepMerge, validateJsonStyle} from '../libs/salmon-utils';

/**
 * Action types
 */
export const SETTINGS_ERROR       = 'SETTINGS_ERROR';
export const SETTINGS_REQUEST     = 'SETTINGS_REQUEST';
export const GET_SETTINGS_SUCCESS = 'GET_SETTINGS_SUCCESS';

export const settingsRequest = () => ({
  type: SETTINGS_REQUEST
})

export const settingsError = (error) => ({
  type: SETTINGS_ERROR,
  error: error,
})

export const getSettings =  (domainId, isLocal = false) => {
  return async (dispatch, getState, api) => {
    dispatch(settingsRequest());
    try {
      //When dynamically load a file, Webpack by default generate a chunk for that module
      //Eager webpack mode forces Webpack to include the file chunk inside the parent bundle/chunk
      //forcing it to not create a separated chunk js
      const {
        default: defaultSettings
      } = await import(/* webpackMode: "eager" */'../defaultJsonStyle.json');
      const {
        default: jsonSchema
      } = await import(/* webpackMode: "eager" */'../../src/schemas/jsonStyleSchema.json');
      let settings =  isLocal
        ? await import(/* webpackMode: "eager" */`../../json-style-files/${domainId}.json`)
        : (await api.get(`/settings/${domainId}`)).data;

      if (defaultSettings && settings.defaultTemplate) {
        // Perform deep merge with array handling
        settings = deepMerge(defaultSettings, settings);

        const validateResult = validateJsonStyle(settings, jsonSchema, true);
        if (!validateResult.isValid) {
          return dispatch(settingsError(validateResult.errors));
        }
      }

      //convert the Module object to normal json object (missing setter in the Module object)
      dispatch(getSettingsSuccess({
        settings: {domain: domainId, ...settings}
      }));
    } catch (error) {
      return dispatch(settingsError(error));
    }
  };
}

export const getSettingsSuccess = (data) => ({
  type: GET_SETTINGS_SUCCESS,
  payload: data,
})